const NotificationBar = ({ pageOneLiner }) => {
  if (!pageOneLiner || pageOneLiner.trim() === "") {
    return null;
  }

  return (
    <div className="flex items-center justify-between p-4 mb-8 text-sm font-semibold text-white bg-blue-800 rounded-lg shadow-md">
      <div className="flex items-center">
        <span>{pageOneLiner}</span>
      </div>
      <span>Soko Bora</span>
    </div>
  );
};

export default NotificationBar;